<template>
    <div>
        <Checkbox
            type="radio"
            class="d-block mb-3"
            checkValue="image"
            name="backgroundType"
            v-model="backgroundType"
        >
            <span class="checkbox-label">Lade <strong>DEIN</strong> Hintergrundbild hoch</span>
        </Checkbox>
        <ImageBackground class="mt-3 mb-5" v-show="backgroundType == 'image'"></ImageBackground>

        <Checkbox
            type="radio"
            class="d-block"
            checkValue="color"
            name="backgroundType"
            v-model="backgroundType"
        >
            <span class="checkbox-label">Verwende <strong>UNSERE</strong> Designvorlagen</span>
        </Checkbox>
        <ColorPresets class="mt-3 mb-3" :wave="wave" :idx="idx" v-show="backgroundType == 'color'"></ColorPresets>
    </div>
</template>

<script type="text/javascript">
import { mapFields } from 'vuex-map-fields';
import ColorPresets from "./ColorPresets.vue";
import Pipeline from '../../../Pipeline/Pipeline';
import Checkbox from "~/scripts/Components/Checkbox.vue";
import ImageBackground from "../3_ColorsBackground/ImageBackground.vue";

export default {
    components: {
        Checkbox,
        ColorPresets,
        ImageBackground
    },

    computed: {
        ...mapFields({
            border: 'stageConfiguration.border',
            image: 'stageConfiguration.background.image',
            backgroundType: 'stageConfiguration.background.type'
        })
    },

    watch: {
        async backgroundType(type) {
            if (type == 'color') {
                this.$root.$emit('disableCropMode');
            }

            // add or remove image background
            await Pipeline.setImageBackground();

            if (type == 'image' && this.image) {
                Pipeline.setBackgroundEffect();
            }

            if (this.border === 'border') {
                Pipeline.updateStageBorder();
                Pipeline.soundFilesToWaveForm();
            }
        }
    }
}
</script>
